import { FC } from 'react';
import { Typography } from '@mui/material';

const Footer: FC = () => {
  return (
    <Typography variant="body2" component="p" sx={styles}>
      &copy; {new Date().getFullYear()} Pathfinder Solutions, PBC
    </Typography>
  );
};

const styles = { color: 'white', fontWeight: '500', textAlign: 'center' };

export { Footer };
